import { Communication } from '../redux/ducks'
import { UIState }       from '../types'

const communicationToLoadableProps = ({ success, error }: Communication) => {
  let ui

  if (success) {
    ui = UIState.loaded
  } else if (error) {
    ui = UIState.failed
  } else {
    ui = UIState.loading
  }

  return {
    ui,
    error,
  }
}

export default communicationToLoadableProps



// WEBPACK FOOTER //
// ./src/project-utils/communication-to-loadable-props.ts